import { Component, OnInit, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { PreviewfileUploadComponent } from 'src/app/common/ngbmodel/previewfile-upload/previewfile-upload.component';
import { UtilsModule } from 'src/app/common/utils/utils.module';
import { AuthloginService } from 'src/app/services/login/authlogin.service';
import { SubmitdataService } from 'src/app/services/submitdata/submitdata.service';
import { isNullOrUndefined } from 'util';

@Component({
  selector: 'app-broadcasting',
  templateUrl: './broadcasting.component.html',
  styleUrls: ['./broadcasting.component.css']
})
export class BroadcastingComponent implements OnInit {
  eventHandle: any;
  outputerror: string;
  selectedFiles: any;
  modelRef: any;
  modalReference: any;
  @ViewChild('submitModal', {}) submitModal;
  docSubject: any;
  fileuploadData: any;
  activeSpinner: boolean;
  dateofSubmission: string;
  selectedYearMonth: object = { 'ay': "", "month": "" };
  yearDropDownList: any;
  monthList: any = [
    { key: '04', value: 'April' },
    { key: '05', value: 'May' },
    { key: '06', value: 'June' },
    { key: '07', value: 'July' },
    { key: '08', value: 'August' },
    { key: '09', value: 'September' },
    { key: '10', value: 'October' },
    { key: '11', value: 'November' },
    { key: '12', value: 'December' },
    { key: '01', value: 'January' },
    { key: '02', value: 'February' },
    { key: '03', value: 'March' },
  ];
  userdetails: any;
  broadcastData: any;
  showDownloadbtn: any;

  constructor(
    private modalService: NgbModal,
    private toastr: ToastrService,
    private submitdataSerivce: SubmitdataService,
    private utils: UtilsModule,
    private logsrv: AuthloginService
  ) { }

  ngOnInit() {
    this.submitdataSerivce.getStatusOfToken();
    this.userdetails = this.logsrv.checkloginstatus();
    this.getdynamicYears();
    this.getCurrentMonth();
  }

  getdynamicYears() {
    let date = new Date();
    let currentYear = date.getFullYear();
    let currentmonth = date.getMonth();
    let dropDownYear;
    if (currentmonth < 3){
      dropDownYear = (currentYear - 1) + '-'+ currentYear;
    } else{
      dropDownYear = currentYear + '-'+ (currentYear + 1);
    } 
    this.submitdataSerivce.getYearsToDisplay(this.submitdataSerivce.yearsPayload).subscribe(data=>{
      this.yearDropDownList = data['data'];
    });
    this.selectedYearMonth['ay'] = dropDownYear;
  }

  getCurrentMonth(){
    let currentmonth = new Date().getMonth();
    this.monthList.forEach(monthObj =>{
      if(monthObj['key'] == currentmonth + 1){
        this.selectedYearMonth['month'] = monthObj['key'];
      }
    })
  }
  filechoosen(event){
    this.eventHandle = event;
    this.outputerror = '';
    if (event.target.files.length > 0){
      // if(this.checkTypeOfFile(event.target.files[0].name)){
      this.selectedFiles = event.target.files[0];      
      // }else{
      //   this.selectedFiles = null;
      // }
    } else {
      this.selectedFiles = null;
    }
  }

  removechosenfile(){
    this.selectedFiles = null;
  }

  public checkTypeOfFile(filename){
    filename = filename.split('.');
    if (filename[filename.length - 1] === 'pdf') {
      return true;
    } else {
      return false;
    }
  }

  previewFileUpload(){
    let originalFile = this.eventHandle.target.files[0];
    let reader = new FileReader();
    reader.readAsDataURL(originalFile);
    reader.onload = () => {
      // let json = JSON.stringify({ dataURL: reader.result });
      // let fileURL = JSON.parse(json).dataURL;
      let myNode = document.getElementById("pdf_file")
      while (myNode.firstChild) {
        myNode.removeChild(myNode.firstChild);
      }

      let originalFileURL = URL.createObjectURL(originalFile);
      //     document.getElementById("pdf_file").insertAdjacentHTML('afterend',`<object data="${originalFileURL}"
      //   type="application/pdf" width="500px" height="600px">
      // </object>`);

      document.getElementById("pdf_file").insertAdjacentHTML('afterend', `<iframe src="${originalFileURL}"
     type="application/pdf" width="500px" height="600px" style="overflow: auto;">
    </iframe>`);
      URL.revokeObjectURL(originalFileURL);
    };

    this.modelRef = this.modalService.open(PreviewfileUploadComponent, { windowClass: 'modal-dialog-centered', centered: true });
  }

  uploadBCdoc(){
    if (this.validateFields()) {
      let postData = {};
      postData["f78f615d-e270-4f93-90ac-27608e756b85"] = this.selectedFiles;
      this.submitdataSerivce.uploadFile(postData).subscribe(data => {
        if (!isNullOrUndefined(data)) {
          this.fileuploadData = data.data;
        }
        this.submitFile(this.fileuploadData);

      });      
    }    
    //  else{
    //   this.toastr.error("please enter all the required ")
    // }
  }

  validateFields() {
    if (this.docSubject && this.selectedFiles) {
      return true;
    } else if (this.docSubject) {
      this.toastr.error("please select document for uploading");
      return false;
    } else {
      this.toastr.error("please enter subject for the document");
      return false;
    }
  }

  submitFile(file) {
    this.activeSpinner = true;
    let uploadData = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      "ay": this.selectedYearMonth['ay'],
      "subTp": this.selectedYearMonth['month'],
      "ts": new Date().getTime(),
      "subject": this.docSubject,
      "file_uuid": file["f78f615d-e270-4f93-90ac-27608e756b85"],
      // "count": 1
    }
    this.submitdataSerivce.uploadbroadcast(uploadData).subscribe(result => {
      if (result) {
        this.toastr.success(result.msg);
        this.selectedFiles = "";
        // this.modalReference.dismiss();
        this.activeSpinner = false;
      } else {
        this.toastr.error(result.msg)
      }
    })

    this.getUpldedDoc();

  }

  getUpldedDoc() {
    this.broadcastData = null;
    let postdata = {
      "pu": "ffce954d-24e1-494b-ba7e-0931d8ad6085",
      "lu": "f78f615d-e270-4f93-90ac-27608e756b85",
      "ay": this.selectedYearMonth['ay'],
      "subTp": this.selectedYearMonth['month'],
      "mode": "COUNT",
      "limit": 1
    }
    this.submitdataSerivce.getBroadcastDetails(postdata).subscribe(data => {
      this.broadcastData = data.data[0];
      if(this.broadcastData.fileUUID){

        this.showDownloadbtn = true;
      }

    })
  }
  
  formatTmStmp(date){
    var datetime : any = new Date(date/1);
    return datetime.toLocaleDateString();
  }

  downloadUpldedDoc(fileUUID) {
    let filesObj = {};
    filesObj['fileUUID'] = fileUUID;
    this.submitdataSerivce.downloadExcelDatas(filesObj).subscribe(data => {
      if (!Array.isArray(data)) {
        let fname = "Notification" + "_" + this.broadcastData.insertTs;
        if (data.type != "application/json") {
          switch (data.type) {
            case 'image/png': {
              fname += '.png'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': {
              fname += '.docx'
              break;
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.pptx'
              break
            }
            case "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
              fname += '.ppt'
              break
            }
            case 'application/octet-stream': {
              // fname+='.jpg'
              fname += '.pdf'
              break;
            }
            case 'application/excel': {
              fname += '.xlsx'
              break;
            }
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': {
              fname += '.xls'
              break;
            }
            case 'image/jpeg': {
              fname += '.jpeg'
              break;
            }
            case 'text/plain': {
              fname += '.txt'
              break;
            }
            case 'application/pdf': {
              fname += '.pdf'
              break;
            }
            case 'image/jpg': {
              fname += '.jpg'
              break;
            }
            default: {
              break;
            }
          }

          this.utils.downloadFile(data, fname);

        } else {
          this.toastr.error("some exception occured")
        }


      }
    })
  }
}
